function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.01,
  width: 25,
  height: 24,
  fill: "#D8D8D8"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.3122 15C21.7504 15 22.9163 13.8807 22.9163 12.5C22.9163 11.1193 21.7504 10 20.3122 10C18.8739 10 17.708 11.1193 17.708 12.5C17.708 13.8807 18.8739 15 20.3122 15Z",
  fill: "#CCD2E0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.9792 15C13.4174 15 14.5833 13.8807 14.5833 12.5C14.5833 11.1193 13.4174 10 11.9792 10C10.5409 10 9.375 11.1193 9.375 12.5C9.375 13.8807 10.5409 15 11.9792 15Z",
  fill: "#CCD2E0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.64567 15C5.08391 15 6.24984 13.8807 6.24984 12.5C6.24984 11.1193 5.08391 10 3.64567 10C2.20743 10 1.0415 11.1193 1.0415 12.5C1.0415 13.8807 2.20743 15 3.64567 15Z",
  fill: "#CCD2E0"
});

var SvgActionOptions = function SvgActionOptions(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgActionOptions, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/actionOptions.98100e19.svg";
export { ForwardRef as ReactComponent };